// src/pages/micro-exercises/MicroExerciseDetailPage.js

import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import { exerciseById } from "../../data/exerciseCatalog";
import ActivityShell from "../../components/capsule/ActivityShell";

export default function MicroExerciseDetailPage() {
  const { exerciseId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const exercise = exerciseById[exerciseId];

  if (!exercise) {
    return (
      <div style={{ padding: "2rem", textAlign: "center", color: "#fff" }}>
        <h2>Exercise not found</h2>
        <button
          onClick={() => navigate("/micro-exercises")}
          style={{
            marginTop: "1rem",
            padding: "0.5rem 1rem",
            borderRadius: "8px",
            border: "none",
            background: "#FA7415",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          Back to exercises
        </button>
      </div>
    );
  }

  const handleClose = () => {
    if (location.state?.from === "capsules") {
      navigate("/micro-exercises", { state: { from: "capsules" } });
    } else {
      navigate("/micro-exercises");
    }
  };

  return (
    <ActivityShell
      exercise={exercise}
      sessionId={null}
      onClose={handleClose}
      onDone={handleClose}
    />
  );
}
